export default __webpack_public_path__ + "static/media/dark-mode.054f2092.svg";